export default __webpack_public_path__ + "static/media/Thumb_Skin_plastic.995843f0.png";